import {useContext} from 'react'
import {DropZone} from '../../../../components/Dropzone'
import ImageItem from '../../components/ImageItem'
import {TicketDetailsPageContext} from '../../context'
import {parseAttachments} from '../../utils'
const AttachmentTab = () => {
  const {
    onUploadDocuments,
    refetchAttachmentListing,
    attachmentListing,
    isLoadingAttachmentListing,
    isLoadingOnDocumentUpload,
    hasTicketWritePermission,
    refetchHistory,
    onDeleteDocument,
  } = useContext(TicketDetailsPageContext)

  const onUploadImages = async (files: any) => {
    const formData: any = new FormData()
    if (Array.isArray(files)) {
      files.forEach((file) => {
        formData.append('files', file)
      })
    } else {
      formData.append('files', files)
    }

    const response: any = await onUploadDocuments(formData)
    if (response?.status === 200) {
      refetchAttachmentListing()
      refetchHistory()
    }
  }

  const handleDeleteAllImages = async (names: any) => {
    await onDeleteDocument(names?.join(','))
    refetchAttachmentListing()
    refetchHistory()
  }

  return (
    <div>
      <DropZone
        id={'attachment'}
        apiFunction={onUploadImages}
        totalFileSize={10}
        selectedImages={parseAttachments(attachmentListing)}
        Component={ImageItem}
        isReplaceable={true}
        isDisabled={!hasTicketWritePermission}
        totalFileSizeWithUploaded={10}
        isRemoveAll={true}
        onDelete={handleDeleteAllImages}
        accept={[
          'image/jpeg',
          'image/png',
          'image/gif',
          'image/webp',
          'image/svg+xml',
          'image/x-icon',
          'video/mp4',
          'video/webm',
          'video/ogg',
          'video/x-msvideo',
          'video/quicktime',
          'video/x-matroska',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.ms-powerpoint',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'text/plain',
          'application/rtf',
          'text/csv',
          'application/xml',
          'application/json',
          'application/zip',
          'application/x-zip-compressed',
          'multipart/x-zip',
          'application/x-tar',
          'application/gzip',
          'application/x-gzip',
          'application/x-7z-compressed',
          'application/x-rar-compressed',
        ]}
        isLoadingFiles={isLoadingAttachmentListing || isLoadingOnDocumentUpload}
        isLoadingData={isLoadingAttachmentListing}
        isDeleteConfirmation={true}
        isTypeMessage={false}
        isDeleteOprationLoading={isLoadingOnDocumentUpload}
      />
    </div>
  )
}

export default AttachmentTab
